import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

const hotList = articles.filter((item) => item.hot).slice(0, 5);
const lead = articles[0];

export default function HeroSection() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 pt-6 md:px-6 md:pt-8">
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          <div className="klg-rise relative overflow-hidden rounded-lg lg:col-span-2">
            <div className="h-[440px] w-full md:h-[560px]">
              <img
                src={lead.cover}
                alt={`${lead.title} 现场图片`}
                title={`${lead.title} - 看料大瓜现场直击`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/35 to-black/10" />
            <div className="absolute inset-x-0 top-0 flex flex-wrap items-center gap-2 p-5 md:p-8">
              <span className="flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-[11px] font-medium text-background-50">
                <span className="h-1.5 w-1.5 rounded-full bg-background-50" />
                现场直击进行中
              </span>
              <span className="rounded-full bg-black/40 px-3 py-1 text-[11px] text-background-100 backdrop-blur">
                看料大瓜实况
              </span>
            </div>
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-8">
              <h1 className="max-w-3xl font-heading text-2xl font-black leading-tight text-white md:text-4xl">
                看料大瓜 · 现场直击，实时追踪热点实况
              </h1>
              <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
                汇聚全网最新鲜的瓜田情报与目击者亲历描述，让你无需四处翻找，即可快速掌握事件来龙去脉。
              </p>
              <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center">
                <Link
                  to={`/article/${lead.id}`}
                  className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-eye-2-line" />
                  查看现场详情
                </Link>
                <Link
                  to="/live"
                  className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/40 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-white/10"
                >
                  浏览全部直击
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </div>

          <aside className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5">
            <div className="flex items-center justify-between">
              <h2 className="flex items-center gap-2 font-heading text-lg font-black text-foreground-950">
                <i className="ri-fire-line text-primary-600" />
                热瓜榜
              </h2>
              <Link
                to="/live"
                className="cursor-pointer text-xs text-foreground-500 transition-colors hover:text-primary-700"
              >
                更多
              </Link>
            </div>
            <p className="mt-1 text-xs text-foreground-500">按实时讨论热度排序</p>
            <ol className="mt-4 flex flex-1 flex-col divide-y divide-background-200">
              {hotList.map((item, index) => (
                <li key={item.id}>
                  <Link
                    to={`/article/${item.id}`}
                    className="group flex cursor-pointer items-start gap-3 py-3"
                  >
                    <span
                      className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-heading text-xs font-black ${
                        index < 3
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-300 text-foreground-700"
                      }`}
                    >
                      {index + 1}
                    </span>
                    <span className="min-w-0">
                      <span className="line-clamp-2 block text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-700">
                        {item.title}
                      </span>
                      <span className="mt-1 block text-[11px] text-foreground-500">
                        {item.categoryName} · {item.views.toLocaleString("zh-CN")} 阅读
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
          </aside>
        </div>
      </div>
    </section>
  );
}